import { ChoiceGroup, IChoiceGroupProps } from "@fluentui/react";
import { FC, useMemo } from "react";
import { ThemeChoiceOption, ThemePreviewColors } from "../../types";
import { ThemePreview } from "../ThemePreview/ThemePreview";
import { themeChoiceStyles } from "./ThemeChoice.styles";

export type ThemeChoiceRenderOption = {
  text: string;
  id?: string;
  checked?: boolean;
  previewColors?: ThemePreviewColors;
};

const renderThemePreview = (option?: ThemeChoiceRenderOption) => {
  if (!option) {
    return null;
  }

  return (
    <ThemePreview
      label={option.text}
      colors={option.previewColors || []}
      htmlFor={option.id}
      checked={option.checked}
    />
  );
};

export interface ThemeChoiceProps {
  options: ThemeChoiceOption[];
  selectedKey?: string;
  onChange: (key: string, option: ThemeChoiceOption) => void;
}

export const ThemeChoice: FC<ThemeChoiceProps> = ({ options, selectedKey, onChange }) => {
  const choiceOptions = useMemo(
    () =>
      options.map((option) => ({
        key: option.key,
        text: option.text,
        previewColors: option.previewColors,
        onRenderField: renderThemePreview,
      })),
    [options]
  );

  const handleChange: IChoiceGroupProps["onChange"] = (_, option) => {
    if (!option) {
      return;
    }

    const selectedOption = options.find((item) => item.key === option.key);

    if (selectedOption) {
      onChange(selectedOption.key, selectedOption);
    }
  };

  return (
    <ChoiceGroup
      selectedKey={selectedKey}
      options={choiceOptions}
      onChange={handleChange}
      styles={themeChoiceStyles}
    />
  );
};
